import $axios from "@/service/httpServer";

export const getProviderType = p => $axios.get(`/prov/bsm/index/category`, p) // 获取供应商类别占比TOP5

export const getProviderArea = p => $axios.get(`/prov/bsm/index/distribution`, p) // 获取供应商分布情况

export const getProviderQuestionList = p => $axios.get(`/prov/bsm/index/feedbackInfo`, p) // 获取供应商待处理问题

export const getProviderIp = p => $axios.get(`/prov/bsm/index/warning`, p) // 获取供应商操作预警
// 待办
export const getProvMessagePageTodo = p => $axios.get(`/prov-base/provMessage/pageTodo`, p)
// 已办
export const getProvMessagePageDone = p => $axios.get(`/prov-base/provMessage/pageDone`, p)
// 消息数量统计
export const getProvMessageMessageCount = p => $axios.postFormData(`/prov-base/provMessage/messageCount`, p)
// 推送一条代办、未读消息
export const getProvMessagePullTodoOne = p => $axios.get(`/prov-base/provMessage/pullTodo`, p, { _showCommonMsg: false })
// 批量置为已办
export const getProvMessageDoneBatch = p => $axios.postFormData(`/prov-base/provMessage/doneBatch`, p)
// 消息通知
export const getProvMessageMessagePage = p => $axios.get(`/prov-base/provMessage/messagePage`, p)
